import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function WithdrawalRestrictedPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center pt-20 md:pt-24 px-4">
        <div className="text-center max-w-md mx-auto">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-stone-100 flex items-center justify-center mx-auto mb-6">
            <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
              <i className="ri-lock-line text-stone-400 text-2xl md:text-3xl" />
            </div>
          </div>
          <h1 className="font-body text-2xl md:text-3xl font-bold text-stone-800 mb-3">
            提領被限制請洽客服
          </h1>
          <p className="font-body text-sm text-stone-400 mb-8 leading-relaxed">
            您的帳號目前處於暫停狀態，提款功能已被限制。<br className="hidden sm:block" />
            如需協助，請聯絡線上客服。
          </p>
          <a
            href="https://line.me/ti/p/hm5V5_QNCq"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 font-body text-base font-semibold px-8 py-3.5 rounded-full bg-stone-800 text-white hover:bg-stone-900 transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-customer-service-line text-lg" />
            </div>
            聯絡線上客服
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}